 <template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
<div class="d-flex align-items-center">
  <el-form inline ref="form" :model="searchform">
      <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value" :placeholder="$t('status.선택')" size="mini" style="width:120px;">
               <el-option
                      v-for="item in searchform.searchOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>
          <el-form-item class="mb-0 mr-0">
             <el-input :placeholder="$t('searchText.키워드')" v-model="searchform.keyword" size="mini" style="width:150px" ></el-input>
          </el-form-item>
           <el-form-item class="mb-0 mr-0">
            <el-button type="info" size="mini" @click="sEvent">{{$t('searchText.검색')}}</el-button>  
           <el-button type="success" size="mini" @click="zpadd">{{$t('tableText.총판생성')}}</el-button>
            <el-button type="primary" v-if="this.sitetype=='4'" size="mini" @click="openModelId">{{$t('newAdd.매장총판업')}}</el-button>
          </el-form-item>
  </el-form>
</div>
  
  <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
       border class="mt-2"
        @sort-change='tableSortChange' 
     :empty-text="$t('tableText.데이타가없습니다')">

       
 <el-table-column
          label="ID"
          type="index"
          align="center"
          width="50">
        </el-table-column>

        <el-table-column
         :label="$t('msg.알본')"
       v-if="this.sitetype==='4' && this.userid=='admin' " prop="admin_id" align="center" >
      </el-table-column>
       <el-table-column
        align="center" :label="$t('tableText.상위')" prop="">
        <template slot-scope="scope">
          {{scope.row.admin_id}}-{{scope.row.boss}}
          </template>
      </el-table-column>
           
      <el-table-column
        :label="$t('nav.아이디')" prop="mem_id" align="center">
          <template slot-scope="scope">
            
             <span @click="openIdModel(scope.row.mem_id,'tab1')" class="text-primary" style="cursor:pointer">{{scope.row.mem_id}} </span>
          </template>
      </el-table-column> 



      <el-table-column
        :label="$t('tableText.이름')" prop="mem_id" align="center">
          <template slot-scope="scope">
            
             <span @click="openAgentModel(scope.row.mem_id)" class="text-primary" style="cursor:pointer"> {{scope.row.mem_name}}({{ scope.row.memState>0 ? 'V'+scope.row.memState:level_title[scope.row.memState]}})</span>
          </template>
      </el-table-column> 

      
     
       <el-table-column
       :label="$t('tableText.하위회원')"
        prop="sum" align="center" width=80>
         <template slot-scope="scope">
             <el-button type="text" @click="openSum(scope.row.mem_id)">{{scope.row.sum}}</el-button>
          </template>
      </el-table-column> 
   <el-table-column
        :label="$t('tableText.충환전')"
        prop="" v-if="this.sitetype!='2'" align="center" width="130px">
        <template slot-scope="scope">
              <el-button-group>
                <el-button type="success"  size="mini" @click="bonOpen(1,scope.row.mem_id,1)">{{$t('msg.충전')}}</el-button>
                <el-button type="primary"  size="mini" @click="bonOpen(1,scope.row.mem_id,2)">{{$t('msg.환전')}}</el-button>
           </el-button-group>
          </template>
      </el-table-column> 

<template v-if="this.aid!='soft10'">
        <el-table-column
        :label="$t('msg.게임머니')" prop="mem_cash" align="center">
        <template slot-scope="scope">
              {{formatMoney(scope.row.mem_cash)}}
          </template>
      </el-table-column> 

       <el-table-column
         :label="$t('msg.포인트롤링')" prop="mem_eventmoney" align="center">
        <template slot-scope="scope">
              {{formatMoney(scope.row.mem_eventmoney)}}
          </template>
      </el-table-column> 
</template>

 <template v-if="this.aid=='soft10' && this.sim!='1'">

    <el-table-column
        :label="$t('msg.알잔액')" prop="mem_cash" sortable="custom" align="center">
        <template slot-scope="scope">
              {{formatMoney(scope.row.mem_cash)}}
          </template>
      </el-table-column> 

          <el-table-column  :label="$t('msg.카슬머니')" prop="api_money" sortable="custom" align="center" >
          <template slot-scope="scope"><span class="text-primary"   style="cursor:pointer">{{ formatMoney(scope.row.api_money)}}</span></template>
        </el-table-column>

        <el-table-column :label="$t('msg.카슬롤링')" prop="mem_eventmoney" sortable="custom" align="center" >
          <template slot-scope="scope"><span class="text-primary"   style="cursor:pointer">{{ formatMoney(scope.row.mem_eventmoney)}}</span></template>
        </el-table-column>

<template v-if=" this.power==='1' ">
        <el-table-column  :label="$t('msg.파워머니')" prop="power_cash" sortable="custom" align="center" >
          <template slot-scope="scope"><span class="text-primary"   style="cursor:pointer">{{ formatMoney(scope.row.power_cash)}}</span></template>
        </el-table-column>

        <el-table-column :label="$t('msg.파워롤링')" prop="power_ecash" sortable="custom" align="center" >
          <template slot-scope="scope"><span class="text-primary"   style="cursor:pointer">{{ formatMoney(scope.row.power_ecash)}}</span></template>
        </el-table-column>
      </template>

      <template v-if=" this.rosing==='1' ">
        <el-table-column :label="$t('newAdd.루징머니')" prop="mem_emoney"  align="center">
          <template slot-scope="scope"><span class="text-primary"   style="cursor:pointer">{{ formatMoney(scope.row.mem_emoney)}}</span></template>
        </el-table-column> 
      </template>

        </template>

        <template v-if="this.aid=='soft10' && this.sim=='1'">

       <el-table-column
        :label="$t('msg.게임머니')" prop="mem_cash" sortable="custom" align="center">
        <template slot-scope="scope">
              {{formatMoney(scope.row.mem_cash)}}
          </template>
      </el-table-column> 

         <el-table-column  :label="$t('msg.카슬머니')" prop="api_money" sortable="custom" align="center" >
          <template slot-scope="scope"><span class="text-primary"   style="cursor:pointer">{{ formatMoney(scope.row.api_money)}}</span></template>
        </el-table-column>
     

        <el-table-column :label="$t('msg.롤링머니')" prop="mem_eventmoney" sortable="custom" align="center" >
          <template slot-scope="scope"><span class="text-primary"   style="cursor:pointer">{{ formatMoney(scope.row.mem_eventmoney)}}</span></template>
        </el-table-column>

        </template>


      

      

     
   <template v-if=" ( this.sitetype==='1' || this.sitetype==='3' || this.sitetype==='4' ) && this.power==='1'">
        <el-table-column  
         :label="$t('msg.파워볼일반')"  prop="event_loing_recom" align="center">
          <template slot-scope="scope">
              {{scope.row.event_loing_recom}}%
          </template>
      </el-table-column> 
        <el-table-column  
        :label="$t('msg.파워볼조합')" prop="event_loing_group_recom" align="center">
          <template slot-scope="scope">
              {{scope.row.event_loing_group_recom}}%
          </template>
      </el-table-column> 
    <!--   <el-table-column  
        label="사다리 일반" prop="event_loing_recom_s" align="center">
          <template slot-scope="scope">
              {{scope.row.event_loing_recom_s}}%
          </template>
      </el-table-column> 
      <el-table-column  
        label="사다리 조합" prop="event_loing_group_recom_s" align="center">
          <template slot-scope="scope">
              {{scope.row.event_loing_group_recom_s}}%
          </template>
      </el-table-column> -->
       </template>

        <template v-if="this.bg==='1'">
       
        <el-table-column  
         :label="$t('msg.보글파일반')"
        prop="event_loing_recom1" align="center">
          <template slot-scope="scope">
              {{scope.row.event_loing_recom1}}%
          </template>
      </el-table-column> 
        <el-table-column  
        :label="$t('msg.보글파조합')"
        label="" prop="event_loing_group_recom1" align="center">
          <template slot-scope="scope">
              {{scope.row.event_loing_group_recom1}}%
          </template>
      </el-table-column> 

       <el-table-column
       :label="$t('msg.보글사일반')"  
        prop="event_loing_recom_s1" align="center">
          <template slot-scope="scope">
              {{scope.row.event_loing_recom_s1}}%
          </template>
      </el-table-column> 
      <el-table-column  
       :label="$t('msg.보글사조합')" prop="event_loing_group_recom_s1" align="center">
          <template slot-scope="scope">
              {{scope.row.event_loing_group_recom_s1}}%
          </template>
      </el-table-column> 

       </template>

       <template v-if="this.sitetype==='4'">
        <el-table-column  
         :label="$t('msg.카지노롤링')" prop="event_loing_recom_e" align="center">
          <template slot-scope="scope">
              {{scope.row.event_loing_recom_e}}%
          </template>
      </el-table-column> 
        <el-table-column  
         :label="$t('msg.슬롯롤링')" prop="event_loing_recom_slot" align="center">
          <template slot-scope="scope">
              {{scope.row.event_loing_recom_slot}}%
          </template>
      </el-table-column> 

<template v-if=" this.rosing==='1' ">
       <el-table-column  
        :label="$t('msg.바카라루징')" prop="pc_e" align="center">
          <template slot-scope="scope">
              {{scope.row.pc_e}}%
          </template>
      </el-table-column> 
        <el-table-column  
     :label="$t('msg.슬롯루징')" prop="pc_slot" align="center">
          <template slot-scope="scope">
              {{scope.row.pc_slot}}%
          </template>
      </el-table-column>

      <el-table-column 
        :label="$t('newAdd.파루징')"  v-if="this.power==='1'" prop="pc_p" align="center">
          <template slot-scope="scope">
              {{scope.row.pc_p}}%
          </template>
      </el-table-column>


    </template>
       
       </template>

       <template v-if="this.sitetype==='2'">
      

<template v-if=" this.rosing==='1' ">
       <el-table-column  
        :label="$t('msg.루징')" prop="pc" align="center">
          <template slot-scope="scope">
              {{scope.row.pc}}%
          </template>
      </el-table-column> 
      
    </template>
       
       </template>


        <el-table-column
        
        :label="$t('msg.가입코드')" v-if="this.sitetype==='1' || this.sitetype==='4'" prop="codelist" align="center" width="130"  >
         <template slot-scope="scope">     
         {{scope.row.reg_code}}   
      </template>
      </el-table-column>

      <el-table-column
        
         :label="$t('msg.가입코드')" v-if="this.sitetype==='20'" prop="codelist" align="center" width="130"  >
         <template slot-scope="scope">
        
         <div v-for="(item,index) in scope.row.codelist" :key="index">
              {{pcode.toUnicode(item)}}
         </div>
        
        
      </template>
      </el-table-column>
     
       <el-table-column
           align="center"
          prop="memState"
          :label="$t('msg.등급')"
          >
          <template slot-scope="scope">
          <el-select :placeholder="$t('status.선택')" v-model="scope.row.memState" size="mini" style="width:80px" @change="changeOptions(scope)">
              <el-option
              v-for="item in lvoptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
            </el-select>
      </template>
          </el-table-column>

      <el-table-column
        :label="$t('tableText.수정')" align="center">
         <template slot-scope="scope">
           <el-button-group>
             <el-button type="primary" @click="zpEdit(scope)" size="mini" icon="el-icon-edit" ></el-button>
             <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteAll(scope)"></el-button>
            </el-button-group>
          </template>
      </el-table-column>
      </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
				  <div style="flex: 1;" class="px-2">
					  <el-pagination
					  :current-page="currentPage"
					  :page-sizes="[5, 10, 15, 20]"
					  :page-size="size"
					  layout="prev, pager, next"
					  :total="total"
					  @size-change="handleSizeChange"
      				  @current-change="handleCurrentChange">
					</el-pagination>
				  </div>
				</el-footer>	
         <el-dialog
         
          :visible.sync="creatModel" :width="layoutWidth1" :close-on-click-modal ="false">

          <el-form ref="form" :model="form" label-width="120px" v-loading="loading" :rules="rules">
            <el-form-item :label="$t('tableText.부본사선택')" prop="boss" class="mb-0 formItem1">
              <el-select v-model="form.boss" :placeholder="$t('searchText.타이틀선택')"  size="mini" prop="boss" filterable>
               <el-option
                      v-for="item in bubonlist"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
            </el-form-item>
             <table class="table table-bordered myTable">
                <tr>
                  <td width="50%">
                     <el-form-item :label="$t('tableText.총판이름')" prop="agent_name" class="mb-0 formItem">
                        <el-input v-model="form.agent_name"></el-input>
                      </el-form-item>
                  </td>
                  <td>
                    <el-form-item :label="$t('nav.아이디')" prop="mem_id" class="mb-0 formItem">
                        <el-input v-model="form.mem_id" class="mr-1"></el-input>
                        <el-button type="primary" size="mini" plain @click="reConfirm">{{$t('msg.확인')}}</el-button>
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>
                    <el-form-item :label="$t('tableText.사용자암호')" :prop="editIndex===-1 ? 'mem_pw' :'empty'" class="mb-0 formItem">
                      <el-input v-model="form.mem_pw"></el-input>
                    </el-form-item>
                  </td>
                  <td>
                     <el-form-item :label="$t('msg.닉네임')" prop="mem_name" class="mb-0 formItem">
                      <el-input v-model="form.mem_name"></el-input>
                    </el-form-item>
                  </td>
                </tr>
                 <tr>
                  <td>
                     <el-form-item :label="$t('msg.가입코드')" prop="reg_code" v-if="this.sitetype!='2'"  class="mb-0 formItem">
                      <el-input v-model="form.reg_code" placeholder=""></el-input>
                    </el-form-item>
                  </td>
                  <td><el-form-item :label="$t('msg.핸드폰')" class="mb-0 formItem">
                      <el-input v-model="form.mem_hp"></el-input>
                    </el-form-item></td>
                </tr>
                 <template v-if=" (this.sitetype==='1' || this.sitetype==='3' || this.sitetype==='4') && this.power==='1' ">
                 <tr>
                  <td>
                    <el-form-item  :label="$t('msg.파워볼일반')"  class="mb-0 formItem" prop="event_loing_recom">
                      <el-input v-model="form.event_loing_recom"></el-input>
                    </el-form-item>
                  </td>
                  <td>
                    <el-form-item :label="$t('msg.파워볼조합')" class="mb-0 formItem" prop="event_loing_group_recom">
                      <el-input v-model="form.event_loing_group_recom"></el-input>
                    </el-form-item>
                  </td>
                </tr>
                <!--<tr>
                  <td>
                     <el-form-item label="사다리 일반" class="mb-0 formItem" prop="event_loing_recom_s">
                      <el-input v-model="form.event_loing_recom_s"></el-input>
                    </el-form-item>
                  </td>
                   <td>
                    <el-form-item label="사다리 조합" class="mb-0 formItem" prop="event_loing_group_recom_s">
                      <el-input v-model="form.event_loing_group_recom_s"></el-input>
                    </el-form-item>
                  </td>
                </tr>-->
              </template>
               <template v-if="this.bg==='1' ">
                 <tr>
                  <td>
                     <el-form-item :label="$t('msg.파워볼일반보글')" class="mb-0 formItem" prop="event_loing_recom1">
                      <el-input v-model="form.event_loing_recom1"></el-input>
                    </el-form-item>
                  </td>
                  <td>
                    <el-form-item :label="$t('msg.파워볼조합보글')" class="mb-0 formItem" prop="event_loing_group_recom1">
                      <el-input v-model="form.event_loing_group_recom1"></el-input>
                    </el-form-item>
                  </td>
                </tr>
                <tr>
                  <td>
                    <el-form-item :label="$t('msg.사다리일반보글')" class="mb-0 formItem" prop="event_loing_recom_s1">
                      <el-input v-model="form.event_loing_recom_s1"></el-input>
                    </el-form-item>
                  </td>
                  <td>
                    <el-form-item :label="$t('msg.사다리조합보글')" class="mb-0 formItem" prop="event_loing_group_recom_s1">
                      <el-input v-model="form.event_loing_group_recom_s1"></el-input>
                    </el-form-item>
                  </td>
                </tr>
              </template>
             
              <template v-if="this.sitetype==='4'">
                 <tr>
                  <td>
                    <el-form-item :label="$t('msg.카지노롤링')" class="mb-0 formItem" prop="event_loing_recom_e">
                      <el-input v-model="form.event_loing_recom_e"></el-input>
                    </el-form-item>
                   </td>
                  <td>
                    <el-form-item :label="$t('msg.슬롯롤링')" class="mb-0 formItem" prop="event_loing_recom_slot">
                      <el-input v-model="form.event_loing_recom_slot"></el-input>
                    </el-form-item>
                  </td>
                </tr>
                  <template v-if="this.rosing==='1'">
                  <tr>
                  <td colspan="2">
                     <div class="d-flex" style="margin-top:0.5rem">
                     <el-form-item :label="$t('msg.바카라루징')" prop="pc_e" class="mb-0 bl">
                        <el-input v-model="form.pc_e"></el-input>
                      </el-form-item>
                       <el-form-item :label="$t('msg.슬롯루징')" prop="pc_slot" class="mb-0 bc">
                      <el-input v-model="form.pc_slot"></el-input>
                    </el-form-item>
                     <el-form-item :label="$t('newAdd.파루징')" v-if="this.power==='1'" prop="pc_p" class="mb-0 bc-ml">
                      <el-input v-model="form.pc_p"></el-input>
                    </el-form-item>
                    </div>


                  </td>
                </tr>
              </template>
               </template> 

                 <tr>
                  <td>
                     <el-form-item :label="$t('tableText.출금비번')" class="mb-0 formItem" :prop="editIndex===-1 ? 'mem_jumin' :'empty'">
                        <el-input v-model="form.mem_jumin"></el-input>
                      </el-form-item>
                  </td>
                  <td>
                    <el-form-item :label="$t('tableText.은행명')" class="mb-0 formItem">
                      <el-input v-model="form.mem_bankcode"></el-input>
                    </el-form-item>
                  </td>
                </tr>
                 <tr>
                  <td>
                     <el-form-item :label="$t('tableText.계좌번호')" class="mb-0 formItem">
                        <el-input v-model="form.mem_banknum"></el-input>
                      </el-form-item>
                  </td>
                  <td>
                    <el-form-item :label="$t('tableText.예금주')" class="mb-0 formItem" prop="mem_bankname">
                      <el-input v-model="form.mem_bankname"></el-input>
                    </el-form-item>
                  </td>
                </tr>
                 <tr>
                  <td>
                     <el-form-item :label="$t('tableText.회수가능')"  v-if="this.sitetype=='4'" class="mb-0 formItem" prop="recy">
                        <el-radio-group v-model="form.recy" class="mt-2">
                          <el-radio label="1">on</el-radio>
                          <el-radio label="0">off</el-radio>
                        
                        </el-radio-group>
                      </el-form-item>

                       <el-form-item :label="$t('msg.루징')" v-if="this.sitetype=='2' && this.rosing=='1'" prop="pc" class="mb-0 formItem">
                        <el-input v-model="form.pc"></el-input>
                      </el-form-item>

                  </td>
                  <td>
                    <el-form-item :label="$t('tableText.상태')"  class="mb-0 formItem">
                      <el-select v-model="form.status" size="mini">
                           <el-option
                                  v-for="item in bubonOptlist"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                          </el-select>
                    </el-form-item>
                  </td>
                </tr>
               
</table>
          </el-form>
          <span slot="footer" class="dialog-footer">
             <el-button @click="creatModel = false">{{$t('msg.취소')}}</el-button>
            <el-button type="primary" @click="submit" :disabled="disabled">{{$t('msg.확인')}}</el-button>
          </span>
        
       
       
        </el-dialog>
       <el-dialog
          :title="$t('newAdd.변경')"
          :visible.sync="creatModelId" :width="layoutWidth1" :close-on-click-modal ="false">

          <el-form ref="form" :model="form" label-width="100px" v-loading="loading" :rules="rules">
             <table class="table table-bordered myTable ">
               <tr>
                  <td style="position:relative" colspan="2">
                    <div class="text-danger text-center" style="padding:10px 0">{{$t('newAdd.매장총판등급업니다')}}</div>
                  </td>
                </tr> 
               <tr>
                <td>
                      
                 

                        <el-form-item :label="$t('newAdd.매장아이디')"  class="mb-0 formItem" prop="mem_id">
                      <el-input v-model="form.mem_id"></el-input>
                    </el-form-item>
                  </td>
   
                </tr>
                 <tr>
                <td>
                      
                 

                        <el-form-item :label="$t('newAdd.하부회원은')"  class="mb-0 formItem" prop="mem_id">
                      <el-input v-model="form.new_shop_id" class="w-50 mr-1"></el-input><span>매장으로이동됩니다</span>
                    </el-form-item>
                  </td>
   
                </tr>
                 
             
               
              </table>
                   
         
                
                
  
          </el-form>
          <span slot="footer" class="dialog-footer">
             <el-button @click="creatModelId = false">{{$t('msg.취소')}}</el-button>
            <el-button type="primary" @click="submitId" :disabled="disabled">{{$t('newAdd.변경')}}</el-button>
          </span>
        
       
       
        </el-dialog>
        
				  <div class="dialogLayer" v-show="shareShow" @click="shareShow=!shareShow">
      </div>  
</div>
 </template>

 <script>
 import layer from '../../components/common/layer.vue';
 import layerNew from '../../components/common/layer-new.vue';
 import zpChildDialog from '../../components/common/zp-child-dialog.vue';
 import shopDialog from '../../components/common/shop-dialog.vue';
 import layoutLayer from '../../components/common/layout-layer.vue';
 import zpAdd from '../../components/common/zp-add.vue';
 import zpEdit from '../../components/common/zp-edit.vue';
 var punycode = require('punycode');
 
    export default {
    components: {
      zpChildDialog,
      shopDialog,
      layer,
      layoutLayer,
      layerNew,
      zpAdd,zpEdit
    },
    	data(){
    		return{
          bonModel:false,
          shareShow:false,
           io_type:'',
            gubun:'1',
             lvoptions: [{
              label: this.$i18n.t("msg.블랙"),
              value: '-2',
             
            }, {
              label: this.$i18n.t("msg.대기"),
               value: '-1',
              
            }, {
              label: this.$i18n.t("msg.기본"),
               value: '0',
             
            }, {
              label: 'v1',
               value: '1',
             
            }, {
              label: 'v2',
               value: '2',
             
            }, {
              label: 'v3',
               value: '3',
             
            }, {
              label: 'v4',
               value: '4',
             
            }, {
              label: 'v5',
               value: '5',
             
            }, {
              label: 'v6',
               value: '6',
             
            }, {
              label: 'v7',
               value: '7',
             
            }, {
              label: 'co',
               value: '8',
             
            }],
           options1: [{
               
                 label: this.$i18n.t("msg.게임머니"),
                 value: '1',
               
              }, {
                label: this.$i18n.t("msg.이벤트머니"),
                 value: '2',
               
              }],
           ioType: [
               {
                label: this.$i18n.t("msg.충전"),
                 value: '1',
               
              }, {
                label:this.$i18n.t("msg.환전"),
                 value: '2',
               
              }],
          dWidth:'400px',
          layLoading:false,
           bonForm:{
            mem_id:'',
            money:'',
            memo:'',
          },
           searchform:{
            time:[],
            keyword:'',
            searchOptions:[
             
             {
              label:this.$i18n.t("msg.아이디"),
              value:'mem_id'
            },
               
           
            {
              label:this.$i18n.t("msg.닉네임"),
              value:'mem_name'
            },
            {
              label:this.$i18n.t("msg.부본"),
              value:'b_code'
            },
            
            {
              label:this.$i18n.t("msg.알본"),
              value:'admin_id'
            } 
            ],
           
            value:'',
          },
          layoutWidth1:'700px',
            bubonOptlist:[{
                 label:this.$i18n.t("msg.정상"),
                value:'1'
            },
            {
                label:this.$i18n.t("msg.차단"),
                value:'0'
            }
            
            ],
           level_title:{
              '-2':this.$i18n.t("msg.블랙"),
              '-1':this.$i18n.t("msg.대기"),
              '0':this.$i18n.t("msg.기본")           
            },
          domain:window.sessionStorage.getItem('domain'),
          sitetype:window.sessionStorage.getItem('sitetype'),
          bg:window.sessionStorage.getItem('bg'),
          power:window.sessionStorage.getItem('power'),
          userid:window.sessionStorage.getItem('userid'),
          aid:window.sessionStorage.getItem('admin_id'),
             rosing:window.sessionStorage.getItem('rosing'),
              sim:window.sessionStorage.getItem('sim'),
          data:[],
          pcode:punycode,
          disabled:false,
          formLoading:false,
          idDialogVisible: false,
          tableLoading:false,
          dialogVisible: false,
          dialogTitle:this.$i18n.t("title.소속회원"), // 标题
          statusObj:{
            '1':this.$i18n.t("msg.정상"),
            '0':this.$i18n.t("msg.차단")
          },
          editIndex:-1,
          creatModel:false,
          statusOptions:[
             {
              label:this.$i18n.t("msg.정상"),
              value:'1'
            },
             {
              label:this.$i18n.t("msg.차단"),
              value:'0'
            },
            {
              label:this.$i18n.t("status.선택"),
              value:''
            },

            ],
            bubonlist:[{
                label:this.$i18n.t("status.선택"),
              value:''
            }
            
            ],
    		  form:{
            new_shop_id:'',
             pc_e:'',
              pc:'',
            pc_slot:'',
            pc_p:'',
            recy:'1',
            agent_name:'',
             boss:'',
            reg_code:'',
            mem_pw:'',
            mem_name:'',
            mem_id:'',
            shop_name:'',
             id:'',
            event_loing_recom:'0',
            event_loing_recom_s:'0',
            event_loing_group_recom:'0',
            event_loing_group_recom_s:'0',

             event_loing_recom1:'0',
            event_loing_recom_s1:'0',
            event_loing_group_recom1:'0',
            event_loing_group_recom_s1:'0',


             event_loing_recom_e:'',
            event_loing_recom_slot:'',
              mem_banknum:'',
            mem_bankcode:'',
            mem_bankname:'',
            mem_jumin:'',
            mem_hp:'',
           
            status:'',
          },
          creatModelId:false,
          optvalue:[
           {
              label:'1',
              value:'1'
            },
             {
              label:'2',
              value:'2'
            },
             {
              label:'3',
              value:'3'
            },


          ],
          valuenum:'1',
    	
		    		 total:0,
		    		 size:0,
		    		 loading: false,
		    		 tableData: [],
			       currentPage:1,
              order:'ascending',
             prop:'',
			       rules: {
                  mem_jumin:[{ required: true, message: '', trigger: 'blur'}],
                  new_shop_id:[{ required: true, message: '', trigger: 'blur'}],

                  event_loing_recom:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_recom_s:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_group_recom:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_group_recom_s:[{ required: true, message: '', trigger: 'blur'}],
                //  recy:[{ required: true, message: '', trigger: 'blur'}],
                  pc_slot:[{ required: true, message: '', trigger: 'blur'}],
                  pc_e:[{ required: true, message: '', trigger: 'blur'}],
                 


                  event_loing_recom_e:[{ required: true, message: '', trigger: 'blur'}],
                  event_loing_recom_slot:[{ required: true, message: '', trigger: 'blur'}],

                  agent_name:[{ required: true, message: '', trigger: 'blur'}],
                  mem_bankname:[{ required: true, message: '', trigger: 'blur'}],
                  //reg_code:[{ required: true, message: '', trigger: 'blur'}],
                  mem_id:[{ required: true, message: '', trigger: 'blur'}],
                  mem_name:[{ required: true, message: '', trigger: 'blur'}],
                  mem_pw:[{ required: true, message: '', trigger: 'blur'}],
                  boss:[{ required: true, message: '', trigger: 'blur'}],
                },
              
			         
			 
    			}
    			
    			
    		},
    		created() {
    			
          //console.log(punycode);
    			this.getList();
    			
			
		},
   
    	methods:{
         tableSortChange(column) {
     console.log('prop',column.prop)
      console.log('order',column.order)
         this.prop= column.prop
         this.order= column.order
         
        this.getList()
     },
           // 删除
      deleteAll(e){
         this.$prompt(this.$i18n.t("msg.삭제하시겠습니까"), this.$i18n.t("msg.알림"), {
          confirmButtonText: this.$i18n.t("msg.삭제"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          inputPlaceholder:this.$i18n.t("newAdd.인증번호"),
          type: 'warning'
        }).then(({ value }) => {
          let token=window.sessionStorage.getItem('user');
   

          this.$axios({
                      method:'post',
                       url:this.domain+'/admin/mem_del?opt='+value+'&mem_id='+e.row.mem_id,
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                    }else{
                      this.$message({
                      message:response.data.msg,
                      type:'error'
                    })
                    }

                     this.loading = false
                    
                    this.getList()
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          }).catch(() => {
          this.$message({
            type: 'info',
             message: this.$i18n.t("msg.취소됨")
          });          
        });

        
      },  
        zpEdit(e){
            console.log('e=',e.$index)
           this.$layer.iframe({
            type: 2,
            title: '수정',
            content: {
                content: zpEdit,
                parent: this,
                data:{
                info:{id:e.row.mem_id},
                eindex:e.$index,
                idx:e.row.idx,
                layerid:'id'
                }
              
            },
            shadeClose: false,
             maxmin : true,

            shade: false,
            area: ['800px', '500px'],
           
        });
        
        },
       zpadd(){
           
           this.$layer.iframe({
            type: 2,
            title: '추가',
            content: {
                content: zpAdd,
                parent: this,
                data:{
               
                layerid:'id'
                }
              
            },
            shadeClose: false,
             maxmin : true,

            shade: false,
            area: ['800px', '500px'],
           
        });
        
        },
         sEvent(){

                if(this.searchform.keyword!='' && this.searchform.value == ''){
                   this.$message(this.$i18n.t("msg.검색타이틀선택하세요"));
                   return;
                }

          this.getList();
          
             

        },
          cancelEvent(){
          this.shareShow = false
        },
         openAgentModel(id){
           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: shopDialog,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            success: function(layero, index) {
              //对加载后的iframe进行宽高度自适应
                //layer.iframeAuto(index);
            },
            shadeClose: false,
             maxmin : true,

            shade: false,
            area: ['1200px','600px'],
           
        });
        
        },
      cutout(cellValue) {

           //cellValue=punycode.toUnicode(cellValue)
           return cellValue.replace(/\,/g, '</br>')
          },
         // 关闭弹框（头部的X）
        
        handleClose1 () {
               this.idDialogVisible = false
            },
        cancelData1(){
          this.idDialogVisible = false
        },
         openIdModel(id,e){

          if(this.aid=='soft10')
           {
            this.shareShow = true

                this.$layer.iframe({
                type: 2,
                title: id,
                content: {
                    content: layerNew,
                    parent: this,
                    data:{
                    info:{id:id},
                    activeTab:e,
                    layerid:'id'
                    }
                  
                },
              
                shadeClose: true,
                maxmin:true,
                shade: false,
                area: ['1200px', '740px'],
                cancel:()=>{
                  this.shareShow = false
                  console.log(close)
                }
                
             
             });

              return;
           }
           
         this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layer,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: ['830px', '680px'],
         
        });
        },
        // 关闭弹框（头部的X）
            handleClose () {
               this.dialogVisible = false
            },
        cancelData(){
          this.dialogVisible = false
        },
       reConfirm(){
               let token=window.sessionStorage.getItem('user');

               if(this.form.mem_id=='')
               {
                    this.$message.error('id error')
                    return;
               }
               this.$axios({
                    method:'post',
                    url:this.domain+'/admin/id_check',
                    data:{
                       mem_id:this.form.mem_id
                    },
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
                }).then((response) =>{ 
                   console.log()
                   if(response.data.code==200)
                      {
                         this.$message({
                          message:response.data.msg,
                          type: 'success'
                        });

                         
                         
                          
                      }else{
                       this.$message.error(response.data.msg)

                      }

                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
            },
        openSum(id){
            this.$layer.iframe({
            type: 2,
            title:this.$i18n.t("title.소속회원"),
            content: {
                content: zpChildDialog,
                parent: this,
                data:{
                info:{id:id},
                layerid:'id'
                }
              
            },
            shadeClose: false,
             maxmin : true,

            shade: false,
            area: ['880px', '700px'],
           
        });
        },
        openModel(e = false){
          let token=window.sessionStorage.getItem('user');


           this.$axios({
                  method:'get',
                  url:this.domain+'/admin/bubonlist_select',
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
              
                 console.log(response.data.data);

                 let newids=[];


           response.data.data.forEach(item=>{
            let obj={};
            obj.label=item.agent_name
            obj.value=item.code
    
            newids.push(obj);

            //console.log('obj',obj);
           });


                this.bubonlist=newids

                 
                  
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })

          if(!e){

            console.log('add');


            this.form = {
                  recy:'1',
                  pc_slot:'',
                  pc_e:'',
                   pc_p:'',
                   pc:'',
                  agent_name:'',
                  reg_code:'',
                  boss:'',
                  mem_pw:'',
                  mem_name:'',
                  mem_id:'',
                  event_loing_group_recom_s:'0',
                  event_loing_group_recom:'0',
                  event_loing_recom:'0',
                  event_loing_recom_s:'0',

                  event_loing_group_recom_s1:'0',
                  event_loing_group_recom1:'0',
                  event_loing_recom1:'0',
                  event_loing_recom_s1:'0',

                  event_loing_recom_e:'',
                  event_loing_recom_slot:'',
                  mem_banknum:'',
                  mem_bankcode:'',
                  mem_bankname:'',
                  mem_jumin:'',
                  mem_hp:'',
                  status:'1'
                  

                 }



           

            //这里调用select接口

            
             this.editIndex = -1

          }
          else{
            //修改
            this.loading = true
            this.$axios({
                  method:'get',
                  url:this.domain+'/admin/zp?id='+e.row.idx,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
              
                  this.loading = false
                  let item = response.data.data
                  console.log('data==',item)
                  
                    this.form = {

                          agent_name:item.agent_name,
                          reg_code:item.reg_code,
                          boss:item.boss,
                          mem_pw:item.mem_pw,
                          mem_name:item.mem_name,
                          id:item.idx,
                          mem_id:item.mem_id,
                          event_loing_recom:item.event_loing_recom,
                          event_loing_recom_s:item.event_loing_recom_s,
                          event_loing_group_recom:item.event_loing_group_recom,
                          event_loing_group_recom_s:item.event_loing_group_recom_s,


                          event_loing_recom1:item.event_loing_recom1,
                          event_loing_recom_s1:item.event_loing_recom_s1,
                          event_loing_group_recom1:item.event_loing_group_recom1,
                          event_loing_group_recom_s1:item.event_loing_group_recom_s1,


                          mem_banknum:item.mem_banknum,
                          mem_bankcode:item.mem_bankcode,
                          mem_bankname:item.mem_bankname,
                          mem_jumin:item.mem_jumin,
                          mem_hp:item.mem_hp,
                        
                           event_loing_recom_e:item.event_loing_recom_e,
                           event_loing_recom_slot:item.event_loing_recom_slot,

                          //bubon_select: item.boss,
                          status:item.status,
                          pc_slot:item.pc_slot,
                          pc_e:item.pc_e,
                           pc_p:item.pc_p,
                          pc:item.pc,
                          recy:item.recy

                }
                this.editIndex = e.$index
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
            })
          }
          this.creatModel = true
        },
         submitId(){

           this.$refs.form.validate((e)=>{
              if(!e) return;

           this.$confirm(this.$i18n.t("newAdd.변경하시겠습니까"), this.$i18n.t("msg.알림"), {
          confirmButtonText: this.$i18n.t("newAdd.변경"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          type: 'warning'
        }).then(({ value }) => {
          
   

                  let token=window.sessionStorage.getItem('user');
             

                 this.disabled = true
                 this.loading =true
                 this.$axios({
                        method:'post',
                        url:this.domain+'/admin/shop_zp_upgrade',
                        data:{
                       
                          mem_id:this.form.mem_id,   
                          new_shop_id:this.form.new_shop_id,      

                        
                        },
                        'Accept': 'application/json',
                         headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                         if(response.data.code !=200)
                            {
                               this.$message({
                            message:response.data.msg,
                            type: 'warning'
                          });


                                
                            }else{
                               this.$message({
                            message:response.data.msg,
                            type: 'success'
                          });
                               //console.log(this.form);
                               this.getList();
                               //this.tableData.unshift(this.form)
                               //关闭
                              
                              this.creatModelId = false

                            }
                           this.loading =false
                           this.disabled = false
                     
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
              
           
           
       

          }).catch(() => {
          this.$message({
            type: 'info',
           message:this.$i18n.t("msg.취소됨")
          });          
        });

           })
             
              
              
            
        },
    		 submit(){
             
              let token=window.sessionStorage.getItem('user');
              this.$refs.form.validate((e)=>{
             if(!e) return;
           
             //添加提交
              if (this.editIndex === -1) {
                 this.disabled = true
                 this.loading =true
               this.$axios({
                        method:'post',
                        url:this.domain+'/admin/zp_insert',
                        data:{
                         agent_name:this.form.agent_name,
                         boss:this.form.boss,
                          reg_code:this.form.reg_code,
                          mem_pw:this.form.mem_pw,
                          mem_name:this.form.mem_name,
                          id:this.form.idx,
                          mem_id:this.form.mem_id,
                          event_loing_recom:this.form.event_loing_recom,
                          event_loing_recom_s:this.form.event_loing_recom_s,
                          event_loing_group_recom:this.form.event_loing_group_recom,
                          event_loing_group_recom_s:this.form.event_loing_group_recom_s,

                          event_loing_recom1:this.form.event_loing_recom1,
                          event_loing_recom_s1:this.form.event_loing_recom_s1,
                          event_loing_group_recom1:this.form.event_loing_group_recom1,
                          event_loing_group_recom_s1:this.form.event_loing_group_recom_s1,


                          event_loing_recom_e:this.form.event_loing_recom_e,
                          event_loing_recom_slot:this.form.event_loing_recom_slot,
                          mem_banknum:this.form.mem_banknum,
                          mem_bankcode:this.form.mem_bankcode,
                          mem_bankname:this.form.mem_bankname,
                          mem_jumin:this.form.mem_jumin,
                          mem_hp:this.form.mem_hp,
                           recy:this.form.recy,
                          pc_slot:this.form.pc_slot,
                          pc_e:this.form.pc_e,
                          pc_p:this.form.pc_p,
                           pc:this.form.pc,
                          status:this.form.status
                        },
                        'Accept': 'application/json',
                         headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                         if(response.data.code !=200)
                            {
                               this.$message({
                            message:response.data.msg,
                            type: 'warning'
                          });


                                
                            }else{
                               this.$message({
                            message:response.data.msg,
                            type: 'success'
                          });
                               //console.log(this.form);
                               this.getList();
                               //this.tableData.unshift(this.form)
                               //关闭
                              
                              this.creatModel = false

                            }
                           this.loading =false
                           this.disabled = false
                     
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
              
            }else{
              
              this.$axios({
                      method:'post',
                      url:this.domain+'/admin/zp_up',
                      data:{
                          agent_name:this.form.agent_name,
                          reg_code:this.form.reg_code,
                          mem_pw:this.form.mem_pw,
                           boss:this.form.boss,
                          mem_name:this.form.mem_name,
                          id:this.form.id,
                          mem_id:this.form.mem_id,
                         event_loing_recom:this.form.event_loing_recom,
                          event_loing_recom_s:this.form.event_loing_recom_s,
                          event_loing_group_recom:this.form.event_loing_group_recom,
                          event_loing_group_recom_s:this.form.event_loing_group_recom_s,

                           event_loing_recom1:this.form.event_loing_recom1,
                          event_loing_recom_s1:this.form.event_loing_recom_s1,
                          event_loing_group_recom1:this.form.event_loing_group_recom1,
                          event_loing_group_recom_s1:this.form.event_loing_group_recom_s1,
                          event_loing_recom_e:this.form.event_loing_recom_e,
                          event_loing_recom_slot:this.form.event_loing_recom_slot,
                          mem_banknum:this.form.mem_banknum,
                          mem_bankcode:this.form.mem_bankcode,
                          mem_bankname:this.form.mem_bankname,
                          mem_jumin:this.form.mem_jumin,
                          mem_hp:this.form.mem_hp,
                        
                          status:this.form.status,
                           recy:this.form.recy,
                          pc_slot:this.form.pc_slot,
                          pc_e:this.form.pc_e,
                            pc_p:this.form.pc_p,
                          pc:this.form.pc
                         
                        },   
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 

                   if(response.data.code==200){
                       this.creatModel = false
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })
                      this.getList()  
                      this.disabled = false
                    }else
                    {
                       //this.creatModel = false
                       this.$message({
                          message:response.data.msg,
                          type:'warning'
                      })
                    }
                    
                   
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })

            }
            })
              
            
        },
			
    		 handleSizeChange(val) {
			        //console.log(`每页 ${val} 条`);
			        this.size = val
			        this.getList();
			        this.loading= true

			      },
			      handleCurrentChange(val) {
			        //console.log(`当前页: ${val}`);
			        this.currentPage = val
			        this.getList();
			        this.loading= true
			      },
			    
         openModelId(){
          
          this.creatModelId = true
        },

           changeOptions(e){
               let token=window.sessionStorage.getItem('user');
               this.$axios({
                    method:'post',
                    url:this.domain+'/admin/mem_level_up',
                    data:{
                       level:e.row.memState,
                       id:e.row.mem_id
                    },
                    'Accept': 'application/json',
                     headers: { 'Authorization': 'Bearer ' + token },
                }).then((response) =>{ 
                   console.log()
                   if(response.data.code==200)
                      {
                         this.$message({
                          message:this.$i18n.t("msg.완료"),
                          type: 'success'
                        });

                          this.getList();
                         
                          
                      }else{
                       this.$message.error(response.data.msg)

                      }

                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
            },
    		getList(){

    		
              
    			this.loading = true

    			 let token=window.sessionStorage.getItem('user');
    				//console.log(token);
    			 let urls=this.domain+'/admin/zplist?page='+this.currentPage+'&'+this.searchform.value+'='+this.searchform.keyword+'&fit='+this.prop+'&order='+this.order;

    			this.$axios({
	                method:'get',
	                url:urls,
	                'Accept': 'application/json',
	                 headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 


                   //  console.log('tableData=',response.data.data)
                     let data = response.data
                     this.tableData =data.data
                     this.total = data.total
                     this.currentPage = data.current_page
                     this.size =data.per_page
                     
                     this.loading =false
               
            }).catch((error) =>{
            	
               this.$message.error(error);
              this.loading = false
               
            })
    		},
     bonOpen(e,id,type){
           this.$layer.iframe({
            type: 2,
            title: '',
            content: {
                content: layoutLayer,
                parent: this,
                data:{
                einfo:{e:e},
                info:{id:id,type:type},

                layerid:'id'
                }
              
            },
            shadeClose: false,
            maxmin:true,
            shade: false,
            area: ['500px', '480px'],
        });
        
        },	
   
    		
    	}
  }
</script>

 <style scoped>

/deep/ .el-dialog__footer {
  padding:0px 20px 20px;
}


/deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }

 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 /deep/ .el-dialog__body{
  padding:10px 20px;
 
 }

</style>


// WEBPACK FOOTER //
// src/views/zp/list.vue